import React from 'react'

export const IconFuel = () => {
  return <img src="https://icongr.am/clarity/fuel.svg?size=16&amp;" alt="icon" />
}
